/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharereviewnav2Inputs */

const en_sharereviewnav2 = /** @type {(inputs: Sharereviewnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback review`)
};

const de_sharereviewnav2 = /** @type {(inputs: Sharereviewnav2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cashback-Prüfung`)
};

/**
* | output |
* | --- |
* | "Cashback review" |
*
* @param {Sharereviewnav2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharereviewnav2 = /** @type {((inputs?: Sharereviewnav2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharereviewnav2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharereviewnav2(inputs)
	return de_sharereviewnav2(inputs)
});
export { sharereviewnav2 as "shareReviewNav" }